import React from 'react';
import { type WrappedComponentProps, injectIntl } from 'react-intl-next';
import AutoProvisionedConfluenceEmptyState from './auto-provisioned-confluence';
import BaseEmptyState from './base-empty-state';
import messages from './messages';
import { type StateProps } from './types';

const EmptyState = ({
	intl,
	spaceKey,
	contentId,
	isConfluenceAutoProvisioned = false,
}: WrappedComponentProps & StateProps) =>
	isConfluenceAutoProvisioned ? (
		<AutoProvisionedConfluenceEmptyState intl={intl} spaceKey={spaceKey} contentId={contentId} />
	) : (
		<BaseEmptyState
			intl={intl}
			spaceKey={spaceKey}
			contentId={contentId}
			description={messages.description}
			primaryActionMessage={messages.createFirstPageButton}
		/>
	);

export default injectIntl(EmptyState);
